var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('Loader',{attrs:{"stretch":"","absolute":""}}):_c('DataHistory',{attrs:{"history-items":_vm.historyItems,"hide-expert-items":_vm.hideExpertItems}})
}
var staticRenderFns = []

export { render, staticRenderFns }